export let CallReturnType = /*#__PURE__*/function (CallReturnType) {
  CallReturnType[CallReturnType["Ok"] = 0] = "Ok";
  CallReturnType[CallReturnType["Error"] = 1] = "Error";
  CallReturnType[CallReturnType["Revert"] = 2] = "Revert";
  return CallReturnType;
}({});

/**
 * @category entry building
 */
export let EntryTag = /*#__PURE__*/function (EntryTag) {
  EntryTag[EntryTag["Account"] = 10] = "Account";
  EntryTag[EntryTag["Oracle"] = 20] = "Oracle";
  EntryTag[EntryTag["Name"] = 30] = "Name";
  EntryTag[EntryTag["Contract"] = 40] = "Contract";
  EntryTag[EntryTag["ContractCall"] = 41] = "ContractCall";
  EntryTag[EntryTag["ChannelOffChainUpdateTransfer"] = 570] = "ChannelOffChainUpdateTransfer";
  EntryTag[EntryTag["ChannelOffChainUpdateDeposit"] = 571] = "ChannelOffChainUpdateDeposit";
  EntryTag[EntryTag["ChannelOffChainUpdateWithdraw"] = 572] = "ChannelOffChainUpdateWithdraw";
  EntryTag[EntryTag["ChannelOffChainUpdateCreateContract"] = 573] = "ChannelOffChainUpdateCreateContract";
  EntryTag[EntryTag["ChannelOffChainUpdateCallContract"] = 574] = "ChannelOffChainUpdateCallContract";
  EntryTag[EntryTag["Channel"] = 58] = "Channel";
  EntryTag[EntryTag["TreesPoi"] = 60] = "TreesPoi";
  EntryTag[EntryTag["StateTrees"] = 62] = "StateTrees";
  EntryTag[EntryTag["Mtree"] = 63] = "Mtree";
  EntryTag[EntryTag["MtreeValue"] = 64] = "MtreeValue";
  EntryTag[EntryTag["ContractsMtree"] = 621] = "ContractsMtree";
  EntryTag[EntryTag["CallsMtree"] = 622] = "CallsMtree";
  EntryTag[EntryTag["ChannelsMtree"] = 623] = "ChannelsMtree";
  EntryTag[EntryTag["NameserviceMtree"] = 624] = "NameserviceMtree";
  EntryTag[EntryTag["OraclesMtree"] = 625] = "OraclesMtree";
  EntryTag[EntryTag["AccountsMtree"] = 626] = "AccountsMtree";
  EntryTag[EntryTag["GaMetaTxAuthData"] = 810] = "GaMetaTxAuthData";
  return EntryTag;
}({});
//# sourceMappingURL=constants.js.map